import { render, staticRenderFns } from "./pageNavBar.vue?vue&type=template&id=55152eba&"
import script from "./pageNavBar.vue?vue&type=script&lang=js&"
export * from "./pageNavBar.vue?vue&type=script&lang=js&"
import style0 from "./pageNavBar.vue?vue&type=style&index=0&id=55152eba&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55152eba')) {
      api.createRecord('55152eba', component.options)
    } else {
      api.reload('55152eba', component.options)
    }
    module.hot.accept("./pageNavBar.vue?vue&type=template&id=55152eba&", function () {
      api.rerender('55152eba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/pageNavBar.vue"
export default component.exports